import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { premiumTickerFontCss } from '@root/entities/pair/ui'
import { PremiumSliderPaired } from '@root/features/premium'

export const PremiumHeroSlider: React.FC = () => (
  <Root>
    <Title>
      <Trans i18nKey="premium.slider.title" components={[<span key={0} />]} />
    </Title>
    <PremiumSliderPaired
      css={css`
        --slider-controls-margin: -20px 0 0;
        --slider-width: 650px;
      `}
    />
  </Root>
)

const Root = styled.div`
  display: grid;
  margin: 0 auto;
  padding-top: 18px;
`

const Title = styled.div`
  color: var(--text-12);

  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  height: 20px;

  font-style: normal;
  text-align: center;

  span {
    ${premiumTickerFontCss}
  }
`
